import { createTheme } from '@mui/material/styles';

const themeClube = createTheme({
  palette: {
    primary: {
      main: '#d30038', // detalhe vermelho
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#000000', // textos
    },
    background: {
      default: '#efe8dd', // bege da logo
    },
    text: {
      primary: '#000000',
      secondary: '#555555',
    },
  },
  typography: {
    fontFamily: 'Georgia, serif', // para lembrar a logo
    h4: {
      fontWeight: 700,
      fontSize: '2rem',
      textTransform: 'uppercase',
    },
    h6: {
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 600,
        },
      },
    },
  },
});

export default themeClube;
